export function getPageVisibilityState() {
    return document.visibilityState;
}
export function getIsPageVisible() {
    return getPageVisibilityState() === 'visible';
}
//# sourceMappingURL=getPageVisibilityState.js.map